export default {
  setCupones(state, d) {
    state.cupones = d;
  }
}